import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';

export default function Search(props) {
  return (
    <div className="flex py-2 items-center w-full">
      <div className="w-full">
        <div className="relative">
          <div className="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center">
            <MagnifyingGlassIcon
              className="h-5 w-5 text-gray-700"
              aria-hidden="true"
            />
          </div>
          <input
            id="search"
            name="search"
            className="block w-full bg-white border border-gray-300 rounded-md py-2 pl-10 pr-3 text-sm placeholder-gray-700 focus:outline-none focus:text-gray-900 focus:placeholder-gray-700 focus:ring-1 focus:ring-rose-500 focus:border-rose-500 sm:text-sm"
            placeholder={props.placeholder}
            type="search"
            onChange={props.onChange}
            value={props.value}
          />
        </div>
      </div>
    </div>
  );
}
